/**
 * Created by Nisarg on 7/25/2017.
 */
import React, {Component} from 'react';
import firebase from 'firebase';
import $ from 'jquery';

import DayPicker, {DateUtils} from 'react-day-picker';
import {ModalContainer, ModalDialog} from 'react-modal-dialog';

import GoogleMapReact from 'google-map-react';
import _HauteFire from './HauteFire';

const HauteFire = new _HauteFire();
const MY_API_KEY = "AIzaSyDlJY0rYEb4YvS_PRm5YBZkCKF5UazJqYw";
var Carousel = require('react-responsive-carousel').Carousel;

export class IslandDetails extends Component {
    constructor() {
        super();

        this.state = {
            IslandDetails: {},
            from: null,
            to: null,
            isModalShown: false,
            isMsgModalShown: false,
            EnquiryDetails: {}
        };
    }

    componentDidMount() {
        $("body, html").animate({
            scrollTop: $("#secIslandBanner").position().top
        });

        const name = this.props.match.params.name;
        const _this = this;

        let islandRef = firebase.database().ref("IslandDetails");
        islandRef.orderByChild("name").equalTo(name).on('value', ((response) => {
            let IslandDetails = response.val();
            if (IslandDetails) {
                IslandDetails = IslandDetails[Object.keys(IslandDetails)];

                if (!$.isEmptyObject(IslandDetails.islandPics)) {
                    const islandPics = IslandDetails.islandPics;
                    if (islandPics) {
                        if (islandPics.hasOwnProperty('otherPics')) {
                            islandPics.otherPics = islandPics.otherPics.filter((img) => {
                                return img != undefined
                            })
                        }

                        const bannerPic = islandPics.bannerPic != undefined ? islandPics.bannerPic.url : "";
                        // $("#secIslandBanner").css({
                        //     "background-image": "url('" + bannerPic + "')",
                        //     'background-size': "cover"
                        // });
                    }
                }
                let EnquiryDetails = this.state.EnquiryDetails;

                EnquiryDetails.Enquiry = {};
                EnquiryDetails.Enquiry.children = "0";
                EnquiryDetails.Recipient = {};
                EnquiryDetails.Recipient.bday = {};
                EnquiryDetails.Recipient.bday.month = "01";


                _this.setState({IslandDetails: IslandDetails, EnquiryDetails: this.state.EnquiryDetails});
            }
        }))

        HauteFire.setBanner();

        //Google Analytics
        HauteFire.hauteGoogleAnalytics();
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.match.params.name != nextProps.match.params.name) {
            this.props = nextProps;
            this.componentDidMount();
        }
    }

    // shouldComponentUpdate(nextProps, nextState) {
    //     debugger;
    //     if (this.props.match.params.name != nextProps.match.params.name) {
    //         this.props = nextProps;
    //         this.componentDidMount();
    //         return true;
    //     }
    //     return true;
    // }

    renderCategories() {
        let categories = this.state.IslandDetails.category.map((category) => {
            return category.name
        }).join(" | ");

        return categories;
    }

    renderActivities() {
        let IslandDetails = this.state.IslandDetails;
        let activities = IslandDetails.activities || [];
        if (activities.length > 0) {
            return activities.join(", ");
        }
    }

    renderIslandGallery(pic, index) {
        // if (index < 4) {
        //     return (
        //         <li key={`pic-${index}`}>
        //             <figure><img src={pic.url} alt={pic.name} style={{height:145}}/>
        //             </figure>
        //         </li>
        //     )
        // }

        return (
            <img key={`pic-${index}`} src={pic.url} alt={pic.name}/>
        )
    }

    renderIslandOnMap() {
        // const style = {
        //     width: '100%',
        //     height: '100%'
        // }

        const location = this.state.IslandDetails.location;
        const lat = location.lat;
        const lng = location.lng;

        return (
            <div style={{width: '100%', height: '400px'}}>

                <GoogleMapReact defaultCenter={{lat: lat, lng: lng}} defaultZoom={14}>

                </GoogleMapReact>

            </div>
        )
    }

    scrollToElem(e) {
        const elemId = e.currentTarget.attributes["data-elemId"].value;
        let diffMargin = 0;
        if (elemId != "explore") {
            diffMargin = 90;

            let elemLI = $(e.currentTarget).parent("li");
            if (elemLI.length > 0) {
                $("li.island-details").removeClass("active");
                $(elemLI).addClass("active");
            }
        }
        $('html, body').animate({
            scrollTop: $("#" + elemId).offset().top - diffMargin
        }, 2000);
    }

    handleDayClick(day) {
        const range = DateUtils.addDayToRange(day, {from: this.state.from, to: this.state.to});
        if (range.from != undefined) {
            this.setState({from: range.from});
        }
        if (range.to != undefined) {
            this.setState({to: range.to});
        }
    }

    handleResetClick(e) {
        e.preventDefault();
        this.setState({from: null, to: null});
    }

    hideModal() {
        this.clearAllControls();
        this.setState({isModalShown: false});
    }

    hideMsgModal() {
        this.setState({isMsgModalShown: false})
    }

    validateEnquiryBox() {
        $(".DayPicker").removeClass("required");
        $("#errDate").hide().html("");
        $("#txtAdults").removeClass("required");
        $("#errAdults").hide();
        $("#txtChildren").removeClass("required");
        $("#errChildren").hide();
        $("#txtRooms").removeClass("required");
        $("#errRooms").hide();

        const fromDate = this.state.from;
        const toDate = this.state.to;
        const txtAdults = $("#txtAdults").val().trim();
        const txtChildren = $("#txtChildren").val().trim();
        const txtRooms = $("#txtRooms").val().trim();

        if (((fromDate && toDate) != null) && txtAdults != "" && txtChildren != "" && txtRooms != "") {
            return true;
        }
        else {
            if ((fromDate && toDate) == null) {
                $(".DayPicker").addClass("required");
                $("#errDate").show().html("Choose date");

                return false;
            }
            if (txtAdults == "") {
                $("#txtAdults").addClass("required").focus();
                $("#errAdults").show().html("Please fill adults");

                return false;
            }
            if (txtChildren == "") {
                $("#txtChildren").addClass("required").focus();
                $("#errChildren").show().html("Please fill children");

                return false;
            }
            if (txtRooms == "") {
                $("#txtRooms").addClass("required").focus();
                $("#errRooms").show().html("Please fill rooms");

                return false;
            }
        }
    }

    showEnqPopup() {
        if (this.validateEnquiryBox()) {
            const IslandDetails = this.state.IslandDetails;
            if (Object.keys(IslandDetails).length > 0) {
                const fromDate = this.state.from;
                const toDate = this.state.to;
                if ((fromDate && toDate) != null) {
                    let {EnquiryDetails} = this.state;
                    EnquiryDetails.Enquiry = EnquiryDetails.Enquiry || {};
                    EnquiryDetails.Enquiry.fromDate = fromDate.toString();
                    EnquiryDetails.Enquiry.toDate = toDate.toString();

                    this.setState({EnquiryDetails, isModalShown: true});
                }
            }
        }
    }

    validateRecipintControls() {
        const elems = $("#formEnq").find("input,select,textarea");
        $(elems).removeClass("reqrecpt");
        $("#errRecpt").hide();

        let isAllValid = true;
        $(elems).each((index, elem) => {
            if ($(elem).val().trim() == "") {
                $(elem).addClass("reqrecpt").focus();
                $("#errRecpt").show();
                isAllValid = false;
                return false;
            }
        });

        return isAllValid;
    }

    createEnquiry(e) {
        e.preventDefault();
        if (this.validateRecipintControls()) {
            let btnSend = document.getElementById("btnSend");
            btnSend.innerHTML = '<i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i> Sending';

            let EnquiryDetails = this.state.EnquiryDetails;
            EnquiryDetails.Island = {};
            EnquiryDetails.Island.islandId = this.state.IslandDetails.id;
            EnquiryDetails.Island.islandBannerUrl = this.state.IslandDetails.islandPics.bannerPic.url;
            EnquiryDetails.Island.islandName = this.state.IslandDetails.name;
            HauteFire.createEnquiry(this.state.EnquiryDetails);
            btnSend.innerHTML = 'Send <i class="fa fa-paper-plane-o ml-1"></i>';

            //Make empty
            const txtAdults = document.getElementById("txtAdults");
            txtAdults.value = "";
            const txtChildren = document.getElementById("txtChildren");
            txtChildren.value = "";
            const txtRooms = document.getElementById("txtRooms");
            txtRooms.value = "";
            this.clearAllControls();
            EnquiryDetails = {};
            EnquiryDetails.children = "0";
            EnquiryDetails.Recipient = {};
            EnquiryDetails.Recipient.bday = {};
            EnquiryDetails.Recipient.bday.month = "01";
            this.setState({EnquiryDetails, from: null, to: null, isModalShown: false, isMsgModalShown: true});
            return false;

            // window.setTimeout(() => {
            //     this.setState({isMsgModalShown: false}).bind(this)
            // }, 5000)
        }
    }

    clearAllControls() {
        //Make empty
        const formEnq = document.getElementById("formEnq");
        formEnq.reset();
        const elems = $("#formEnq").find("input,select,textarea");
        $(elems).removeClass("reqrecpt");
        $("#errRecpt").hide();
    }

    renderIslandDescription() {
        let description = this.state.IslandDetails.description.trim();
        // description = $(description).text();
        // description = description.replace(/\n/g, "<br/>");
        let _description = "";
        $(description).find("span").each((index, elem) => {
            _description += "<p>" + $(elem).text() + "</p><br/>"
        });
        if (_description == "") {
            $(description).each((index, elem) => {
                if (elem.childNodes.length > 0) {
                    _description += "<p>" + $(elem).text() + "</p><br/>"
                }
            })
        }
        $("#divIslandAboutUs").html(_description);
    }

    render() {
        const {from, to} = this.state;

        return (
            <div>

                <section id="secIslandBanner" className="sec-banner banner parallax-property">
                    <img className="img-banner bannerpic"
                         src={!$.isEmptyObject(this.state.IslandDetails) && this.state.IslandDetails.hasOwnProperty('islandPics') ? this.state.IslandDetails.islandPics.bannerPic.url : ""}
                         alt={!$.isEmptyObject(this.state.IslandDetails) ? this.state.IslandDetails.name : ""}/>
                    <div className="div-explore hautecontainer">
                        <h1>{!$.isEmptyObject(this.state.IslandDetails) ? this.state.IslandDetails.name : ""}</h1>
                        <span className="banner-content"
                              style={{textShadow: '2px 2px #484848'}}>{!$.isEmptyObject(this.state.IslandDetails.tagLine) ? this.state.IslandDetails.tagLine : ""}</span>
                        <a className="explore-btn button" data-id="#explore" data-elemId="explore"
                           style={{cursor: 'pointer'}} onClick={(e) => this.scrollToElem(e)}>KNOW MORE</a>
                    </div>
                </section>

                <section className="private-island" id="explore">
                    <div className="hautecontainer clearfix">
                        <div className="private-island-content">
                            <h2 className="heading">{this.state.IslandDetails.name}<span>
                                {!$.isEmptyObject(this.state.IslandDetails.address) ? this.state.IslandDetails.address.substr(this.state.IslandDetails.address.lastIndexOf(',') + 1).trim() : ""}
                            </span></h2>

                            <div className="private-island-area">
                                <div className="clearfix availabel-list">
                                    <span className="island-info">
                                        {!$.isEmptyObject(this.state.IslandDetails) ? this.state.IslandDetails.category.length > 0 ? this.renderCategories() : "" : ""}
                                    </span>
                                    <span className="island-info">ROOMS <span
                                        className="light-text">{!$.isEmptyObject(this.state.IslandDetails) && !$.isEmptyObject(this.state.IslandDetails.rooms) ? this.state.IslandDetails.rooms : ""}</span></span>
                                    {!$.isEmptyObject(this.state.IslandDetails) && !$.isEmptyObject(this.state.IslandDetails.guests) ?
                                        <span className="island-info">GUESTS <span
                                            className="light-text">  {this.state.IslandDetails.guests}</span></span> : ""}
                                </div>

                                <span className="light-text"><strong className="island-info">ACTIVITIES</strong>
                                    {!$.isEmptyObject(this.state.IslandDetails) ? !$.isEmptyObject(this.state.IslandDetails.activities) ? this.renderActivities() : "" : ""}
                                </span>
                            </div>
                            <div className="private-island-info">
                                <ul className="clearfix">
                                    <li className="island-details active">
                                        <a style={{cursor: 'pointer'}} data-elemId="divIslandAboutUs"
                                           onClick={(e) => this.scrollToElem(e)}>ABOUT</a>
                                    </li>
                                    <li className="island-details">
                                        <a style={{cursor: 'pointer'}} data-elemId="secIslandGallery"
                                           onClick={(e) => this.scrollToElem(e)}>GALLERY</a>
                                    </li>
                                    <li className="island-details">
                                        <a style={{cursor: 'pointer'}} data-elemId="secIslandMap"
                                           onClick={(e) => this.scrollToElem(e)}>MAP</a>
                                    </li>
                                </ul>

                                <div id="divIslandAboutUs">
                                    {/*
                                     <p>
                                     {!$.isEmptyObject(this.state.IslandDetails) ? $(this.state.IslandDetails.description).text() : ""}
                                     </p>
                                     */}
                                    <p>
                                        {!$.isEmptyObject(this.state.IslandDetails) ? this.renderIslandDescription() : ""}
                                    </p>
                                </div>

                            </div>
                        </div>

                        <form className="enquery-form">
                            <div className="form-info clearfix">
                                <div className="form-element">
                                    <label className="enquery-label">Choose date</label>

                                    <DayPicker
                                        numberOfMonths={1}
                                        disabledDays={{before: new Date()}}
                                        selectedDays={[from, {from, to}]}
                                        onDayClick={this.handleDayClick.bind(this)}
                                    />
                                    <span id="errDate" className="errmsg" style={{display: 'none'}}></span>
                                </div>
                            </div>
                            {/*
                             <div className="form-element">
                             <input className="checkbox-wrap" type="checkbox" id="check"/>
                             <label className="flexible-date" htmlFor="check"><span className="check-box"></span> My
                             dates are flexible by +/-5 days</label>

                             </div>
                             */}
                            <div className="form-element guest-box">
                                <label className="enquery-label">Adults</label>
                                <input id="txtAdults" className="form-area adults-pic" type="number" min="1"
                                       onChange={(e) => {
                                           let adults = e.currentTarget.value.trim();
                                           if (adults != "") {
                                               let EnquiryDetails = this.state.EnquiryDetails;
                                               EnquiryDetails.Enquiry = EnquiryDetails.Enquiry || {};
                                               EnquiryDetails.Enquiry.adults = adults;

                                               this.setState({EnquiryDetails});
                                           }
                                       }}/>
                                <span id="errAdults" className="errmsg" style={{display: 'none'}}></span>
                            </div>
                            <div className="form-element guest-box">
                                <label className="enquery-label">Children</label>
                                <input id="txtChildren" className="form-area child-pic" type="number" min="0"
                                       defaultValue="0" onChange={(e) => {
                                    let children = e.currentTarget.value.trim();
                                    if (children != "") {
                                        let EnquiryDetails = this.state.EnquiryDetails;
                                        EnquiryDetails.Enquiry = EnquiryDetails.Enquiry || {};
                                        EnquiryDetails.Enquiry.children = children;

                                        this.setState({EnquiryDetails});
                                    }
                                }}/>
                                <span id="errChildren" className="errmsg" style={{display: 'none'}}></span>
                            </div>
                            <div className="form-element guest-box">
                                <label className="enquery-label">Rooms</label>
                                <input id="txtRooms" className="form-area room-pic" type="number" onChange={(e) => {
                                    let rooms = e.currentTarget.value.trim();
                                    if (rooms != "") {
                                        let EnquiryDetails = this.state.EnquiryDetails;
                                        EnquiryDetails.Enquiry = EnquiryDetails.Enquiry || {};
                                        EnquiryDetails.Enquiry.rooms = rooms;

                                        this.setState({EnquiryDetails});
                                    }
                                }}/>
                                <span id="errRooms" className="errmsg" style={{display: 'none'}}></span>
                            </div>
                            <button className="button enquiry-btn" type="button"
                                    onClick={this.showEnqPopup.bind(this)}>
                                ENQUIRE NOW
                            </button>
                        </form>

                    </div>
                </section>

                <section id="secIslandGallery" className="property-gallery-sec">
                    <div className="hautecontainer">
                        <h2 className="property-head">gallery</h2>


                        {!$.isEmptyObject(this.state.IslandDetails) && !$.isEmptyObject(this.state.IslandDetails.islandPics) && !$.isEmptyObject(this.state.IslandDetails.islandPics.otherPics) ?
                            <Carousel showArrows={true} dynamicHeight emulateTouch useKeyboardArrows>
                                {this.state.IslandDetails.islandPics.otherPics.map((pic, index) => {
                                    if (pic != (null || undefined)) {
                                        return this.renderIslandGallery(pic, index)
                                    }
                                })}
                            </Carousel> : ""}

                    </div>
                </section>
                <section id="secIslandMap" className="map-sec">
                    <div className="hautecontainer">
                        <h2 className="property-head">Map</h2>
                        <figure>
                            {!$.isEmptyObject(this.state.IslandDetails) ? this.renderIslandOnMap() : ""}
                        </figure>
                    </div>
                </section>

                {this.state.isModalShown ? <ModalContainer onClose={this.hideModal.bind(this)} style={{width: 400}}>
                        <ModalDialog onClose={this.hideModal.bind(this)} style={{width: 400}}>

                            <form id="formEnq">
                                <p className="h5 text-center mb-4">Write to us</p>

                                <div className="md-form">
                                    <input type="text" id="txtName" className="form-control" onChange={(e) => {
                                        let name = e.currentTarget.value.trim();
                                        let EnquiryDetails = this.state.EnquiryDetails;
                                        if (name != "") {
                                            EnquiryDetails.Recipient.name = name;

                                            this.setState({EnquiryDetails});
                                        }
                                    }
                                    }/>
                                    <label htmlFor="txtName">Name</label>
                                </div>

                                <div className="md-form">
                                    <input type="email" id="txtEmail" className="form-control" onChange={(e) => {
                                        let email = e.currentTarget.value.trim();
                                        let EnquiryDetails = this.state.EnquiryDetails;
                                        if (email != "") {
                                            EnquiryDetails.Recipient.email = email;

                                            this.setState({EnquiryDetails});
                                        }
                                    }
                                    }/>
                                    <label htmlFor="txtEmail">Email</label>
                                </div>

                                <div className="md-form">
                                    <input type="text" id="txtContactNumber" className="form-control" onChange={(e) => {
                                        let contactNumber = e.currentTarget.value.trim();
                                        let EnquiryDetails = this.state.EnquiryDetails;
                                        if (contactNumber != "") {
                                            EnquiryDetails.Recipient.contactNumber = contactNumber;

                                            this.setState({EnquiryDetails});
                                        }
                                    }}/>
                                    <label htmlFor="txtContactNumber">Contact number</label>
                                </div>

                                <div className="md-form bday">
                                    <label className="dob">Date of birth</label>
                                    <div className="enq-bday bday-month">
                                        <label htmlFor="txtMonth">Month</label>
                                        <select id="dlMonth" className="form-control" onChange={(e) => {
                                            let month = e.currentTarget.value.trim();
                                            let EnquiryDetails = this.state.EnquiryDetails;
                                            EnquiryDetails.Recipient.bday.month = month;

                                            this.setState({EnquiryDetails});
                                        }
                                        }>
                                            <option value="01">Jan</option>
                                            <option value="02">Feb</option>
                                            <option value="03">Mar</option>
                                            <option value="04">Apr</option>
                                            <option value="05">May</option>
                                            <option value="06">Jun</option>
                                            <option value="07">Jul</option>
                                            <option value="08">Aug</option>
                                            <option value="09">Sep</option>
                                            <option value="10">Oct</option>
                                            <option value="11">Nov</option>
                                            <option value="12">Dec</option>
                                        </select>
                                    </div>

                                    <div className="enq-bday bday-date">
                                        <label
                                            htmlFor="txtDate"> Date
                                        </label>
                                        <input type="number" id="txtDate" className="form-control" min="1" max="31"
                                               onChange={(e) => {
                                                   let date = e.currentTarget.value.trim();
                                                   let EnquiryDetails = this.state.EnquiryDetails;
                                                   if (date != "") {
                                                       EnquiryDetails.Recipient.bday.date = date;

                                                       this.setState({EnquiryDetails});
                                                   }
                                               }}/>
                                    </div>

                                    <div className="enq-bday bday-year">
                                        <label htmlFor="txtYear"> Year</label>
                                        <input type="number" id="txtYear" className="form-control" onChange={(e) => {
                                            let year = e.currentTarget.value.trim();
                                            let EnquiryDetails = this.state.EnquiryDetails;
                                            if (year != "") {
                                                EnquiryDetails.Recipient.bday.year = year;

                                                this.setState({EnquiryDetails});
                                            }
                                        }}/>
                                    </div>
                                </div>

                                <div className="md-form">
                                <textarea type="text" id="txtEnquiry" className="md-textarea" style={{height: 100}}
                                          onChange={(e) => {
                                              let enquiry = e.currentTarget.value.trim();
                                              let EnquiryDetails = this.state.EnquiryDetails;
                                              if (enquiry != "") {
                                                  EnquiryDetails.Recipient.enquiry = enquiry;

                                                  this.setState({EnquiryDetails});
                                              }
                                          }}>
                                </textarea>
                                    <label htmlFor="txtEnquiry"> Enquiry</label>
                                </div>
                                <div className="md-form">
                                <span id="errRecpt" className="errmsg"
                                      style={{display: 'none'}}>All fields are mendatory</span>
                                </div>
                                <div className="text-center">
                                    <button id="btnSend" className="btn btn-unique" onClick={this.createEnquiry.bind(this)}>
                                        Send
                                        <i className="fa fa-paper-plane-o ml-1"></i>
                                    </button>
                                </div>
                            </form>

                        </ModalDialog>
                    </ModalContainer>
                    :
                    ""
                }

                {this.state.isMsgModalShown ?
                    <ModalContainer onClose={this.hideMsgModal.bind(this)}>
                        <ModalDialog onClose={this.hideMsgModal.bind(this)}>
                            <p>Thank you for your inquiry. We will get back to you soon!</p>
                        </ModalDialog>
                    </ModalContainer> : ""}

            </div>
        )
    }
}

export default IslandDetails



// WEBPACK FOOTER //
// ./src/IslandDetails.js